import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { AuthProvider } from 'modules/auth/context/AuthContext';
import { AUTH_ROUTES } from 'components/routes';

const AuthRoutes: React.FC = () => {
  return (
    <AuthProvider>
      <Routes>
        {AUTH_ROUTES.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
      </Routes>
    </AuthProvider>
  );
};

export default AuthRoutes;
